import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Index from '@/components/Index'
import Error from '@/components/404'

import Home from '@/components/Home'
import Solution from '@/components/Solution'
import Product from '@/components/Product'
import Casus from '@/components/Casus'
import Support from '@/components/Support'
import About from '@/components/About'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			component: Index,
			children: [{
					path: '/',
					name: "Home",
					component: Home
				},
				{
					path: '/solution',
					component: Solution
				},
				{
					path: '/product',
					component: Product
				},
				{
					path: '/product/:index',
					component: Product
				},
				{
					path: '/casus',
					component: Casus
				},
				{
					path: '/support',
					component: Support
				},
				{
					path: '/support/:index',
					component: Support
				},
				{
					path: '/about',
					component: About
				},
				{
					path: '/about/:index',
					component: About
				},
			]
		},
		{
			path: '/404',
			name: '404',
			component: Error
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js